import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'seamless-immutable';
import styled from 'styled-components';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

const UsedDisclaimer = ({ currentSku, history }) => {
  const condition = getIn(currentSku, ['offers', 'result', 0, 'condition'], null);
  return (
    condition === 'USED' && (
      <Box>
        <Text>
          <Bold>Usado:</Bold> Este produto pode ter pequenas marcas ou sinais de uso. Mas não se preocupe, viu?
          Americanas garante o bom estado do item.
        </Text>
        <Link onClick={replaceUrlParams(history, '#modal-product-disclaimer', false, { condition })}>
          regras sobre produto usado
        </Link>
      </Box>
    )
  );
};

const Text = styled.p`
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const Bold = styled.strong`
  color: ${({ theme }) => theme.grey.dark};
  font-weight: bold;
`;

const Link = styled.a`
  padding-top: 20px;
  display: flex;
  align-items: center;
  text-decoration: underline;
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
  &:active {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const Box = styled.div`
  margin-bottom: 30px;
`;

UsedDisclaimer.propTypes = {
  history: PropTypes.object,
  product: PropTypes.object,
};

export default UsedDisclaimer;
